export const TABS_WIDTH = 60;
export const FULL_ASSET_WIDTH = 765;
export const ASSET_SIDE_BY_SIDE_WIDTH = 690;
export const ASSET_SIDE_BY_SIDE_HEIGHT = 460;
